
import Vue from 'vue';
import DateRange from '../../components/DateRange.vue';
import GroupSelector from '../../components/GroupSelector.vue';
import WidgetSelector from '../../components/WidgetSelector.vue';
import ArchivedWidgetsSelector from '../../components/ArchivedWidgetsSelector.vue';
import GroupBy from '../../components/GroupBy.vue';
import ViewBy from '../../components/ViewBy.vue';
import Statistics from '../../components/Statistics.vue';
import Moment from 'moment';
import { IGroup, IWidget, IDescriptions } from '../../store/insights';
import { handleGraphQLErrors } from '~shared/utils/graphql-helper';
import { normalizeDateRange } from '~shared/utils';

interface IData {
  profile: string;
  missingWidgets: boolean;
  dateRange: any[];
  isNoData: boolean;
  isDownloadLoading: boolean;
}

export default Vue.extend({
  components: {
    GroupBy,
    ViewBy,
    DateRange,
    GroupSelector,
    WidgetSelector,
    Statistics,
    ArchivedWidgetsSelector,
  },
  data(): IData {
    return {
      profile: this.$store.state.auth.user,
      missingWidgets: false,
      dateRange: [],
      isNoData: true,
      isDownloadLoading: false,
    };
  },
  computed: {
    includeArchivedWidgets(): boolean {
      return this.$store.state.insights.filters.includeArchivedWidgets;
    },
    lastUpdated(): Moment.Moment | null {
      return this.$store.state['insights'].lastUpdated;
    },
    showingCount(): number {
      return this.$store.state['insights'].showingCount;
    },
    selectedGroup(): IGroup | null {
      return this.$store.state['insights'].filters.selectedGroup;
    },
    selectedWidgets(): IWidget[] {
      return this.$store.state['insights'].filters.selectedWidgets;
    },
    groupBy(): string {
      return this.$store.state['insights'].filters.groupBy;
    },
    initialized(): boolean {
      return this.$store.getters['insights/initialized'];
    },
    loading(): boolean {
      return this.$store.state['insights'].fetchingStatistics;
    },
    filtersChanged(): boolean {
      return this.$store.getters['insights/filtersChanged'];
    },
    fetchedDataDescriptions(): IDescriptions {
      return this.$store.state['insights'].fetchedDataDescriptions;
    },
    statisticsCount(): number {
      return this.$store.state['insights'].statistics.length;
    },
  },
  methods: {
    setMissingWidgets(status: boolean): void {
      this.missingWidgets = status;
    },
    setDateRangeHandler(val) {
      this.dateRange = val;
    },
    async downloadFullReport() {
      this.isDownloadLoading = true;
      const group = this.$route.query.group;
      const view = this.$route.query.view as string || 'DAY';
      const groupBy = this.$route.query.groupby as string || 'TOTAL';

      const { startDate, endDate } = normalizeDateRange({ startDate: this.dateRange[0], endDate: this.dateRange[1] });

      let url = `${process.env.restApiEndpoint}/reports`;
      if (group) {
        url += `/${group}/widget/download`;
      }

      try {
        const response = await this.$axios({
          url,
          params: {
            start_date: startDate.toISOString(),
            end_date: endDate.toISOString(),
            include_archived_widgets: this.includeArchivedWidgets,
            resolution: view.toUpperCase(),
            group_by: groupBy.toUpperCase()
          },
          method: 'GET',
          responseType: 'blob'
        })

        // ==== DOWNLOAD PROCESS START ====
        let fileName = 'Report.xlsx';
        const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = blobUrl;

        // dynamic filename
        const contentDisposition = response.headers['content-disposition'];
        if (contentDisposition) {
          const split = contentDisposition.split(';');
          if (split.length > 1) {
            fileName = split[1].replace(/filename=/, '');
          }
        }

        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
        this.isDownloadLoading = false;
        // ==== DOWNLOAD PROCESS END ====


      } catch (error) {
        this.$snotify.error(handleGraphQLErrors(error));
        this.isDownloadLoading = false;
      }
    },
  },
});
